import React from "react";
import Button from "../../../../component/button/Button";
import { useSelector } from "react-redux";

const MicroJobNotFound = (props: any) => {
    

    const { navigateToJob, navigateToJobAlerts } = props;

  
    return (
        <>
            <div className={"job-search-box "}>
                <div className="btn-section mt-3">
                    <div className="text-center">
                        <h2 className="job-view-text">No job matches.</h2>
                        <p className="infi-text">Please try again later.
                        </p>
                    </div>
                   
                </div>
            </div>
        </>
    );
};

export default MicroJobNotFound;